{
    "evergreen-connector": {
        "general": {
            "assets": [
                "d6c7dc0c-ac97-4fda-bd6b-99cfaa4bedbf",
                "e5c2081c-fda7-47a7-8b0c-fa785571dd83",
                "3def4831-5b55-4c91-9e0a-a3ab233338fd",
                "a5e4f0cb-b98a-4f5f-bf29-f6bf2bdd2b6f",
                "22cd9e1a-88c1-41b2-af75-525a0e11bcde"
            ]
        }
    },
    "evergreen-educator": {
        "general": {
            "assets": [
                "87baa554-d5fb-475b-9a04-08180fbeede4",
                "c4d4f55e-96f8-4bf8-84e4-f80b2f4a1200",
                "d57d0910-a53b-47f8-9a96-ce9934e25d04",
                "a083c932-7f5b-40cc-8b4c-2255d61ebe8a"
            ]
        }
    },
    "capital-powers": {
        "general": {
            "assets": ["80fd8e2b-45b3-4c54-a45e-1f356aeed2ce", "97006309-1e7e-4892-9438-d63ebb839cb8", "a4d75151-0335-4bcc-9308-5561457072a4"]
        }
    },
    "digital-citizenship": {
        "meta": true,
        "careers": {
            "name": "Careers",
            "assets": [
                "a9b9b540-1e71-4880-a2b2-0683d188cee0",
                "239d71cf-b7f0-4846-a9c1-b7c8a68f9f83",
                "32c832d6-09c6-4d25-ad1e-cf9e155c7ff8",
                "6e86baf8-6a2e-475b-8545-259f58fdb492",
                "4b05e9e6-99de-49f7-b858-7131c069da22",
                "534070d1-a92f-401e-ae6c-61120f659a06"
            ]
        },
        "digital-footprint": {
            "name": "Digital Footprint",
            "assets": [
                "9e449a81-9ea0-46b0-84fc-8d6b6ed6cca2",
                "738f6298-9cb5-4d36-909c-16743ebf35a8",
                "91528897-e0db-4204-8fb3-e11ff0b59a37",
                "467cd7fa-f8ba-421a-b89e-706e81cee946",
                "458d7ce9-6203-4ccf-a14f-0ad2a4263a30"
            ]
        },
        "digital-privacy": {
            "name": "Digital Privacy",
            "assets": ["d8304606-4989-4937-892c-e882409eb508", "58f4f2ed-3ee0-4637-b176-4a11097a9e62"]
        },
        "online-interactions": {
            "name": "Online Interactions",
            "assets": [
                "189e3ad4-1b4e-42e9-bc60-b38126cb8928",
                "f3e7d7ad-a089-47b0-b67e-a0c68a48b402",
                "c2b42ca2-5c13-4e38-b6b0-9c216f390179",
                "e32f6a07-31db-46d2-abe2-5381c74377df",
                "e77cd014-e973-4743-82d8-4245838ed13f",
                "7f37c065-f8fd-4c1c-a584-a11eab4fe77b"
            ]
        },
        "safeguard-well-being": {
            "name": "Safeguard Well-being",
            "assets": ["9d439594-50f3-4621-a440-10ed997fec98", "51521906-8a2e-4a8e-910c-9f4c02e40680", "b89ec266-fcc8-4d4c-81e1-79817ff2a125"]
        }
    },
    "stem-day": {
        "general": {
            "name": "Prepare for a virtual visit with a STEM Career Volunteer by taking on the role of an industry professional",
            "assets": [
                "e4c591b5-8367-4145-9139-6b6a3e7fc538",
                "bbe4386d-4edb-4d37-a0e4-154baa39c380",
                "63a9db74-db94-4d18-b255-46301bd1b8fc",
                "d042e341-e031-45a2-bdea-35bb8ea7f751"
            ]
        },
        "physical-world": {
            "name": "Explore how to innovate the future and solve for problems impacting the physical world around us",
            "assets": [
                "03188c4a-fa35-4051-bd59-b2f1bb251254",
                "9ec4d386-0266-41f0-b45b-b89d2b313cb8",
                "e2b5f332-9cf1-4b0a-99f2-dd05c5208238",
                "487ef364-e999-4035-b8aa-928c7d5f822e",
                "5cd7a92c-ef29-4222-aca5-b4c689777a19",
                "ea6c290e-659a-40cb-8554-d657743ece1e"
            ]
        },
        "digital-world": {
            "name": "Practice solution seeking skills and consider how to solve problems in the digital world",
            "assets": [
                "a75cd8d2-b41c-4b03-b452-2616275909b7",
                "5f6bb09f-38ac-4c0a-9e03-b38ca2603ba1",
                "d8304606-4989-4937-892c-e882409eb508",
                "9529329c-2c39-4bfb-ab53-247d35610da7",
                "4c14bf6b-5d55-4295-a8b6-cec01108fe8d",
                "b579b8f5-1fac-4d12-a916-d4c8bcd88e0b"
            ]
        }
    },
    "workforce-development": {
        "meta": true,
        "develop": {
            "name": "Develop verbal and written communication skills and engage in discussions with professionals",
            "assets": [
                "af38bb59-8032-4b67-b0d1-c7ed78b00fab",
                "a7e5ddad-002f-4610-89a0-d8c13ffe10ba",
                "1e6c211d-97c6-49f2-86d1-059894267825",
                "51d218ba-fad6-499a-a85b-aa95d289d654"
            ]
        },
        "explore": {
            "name": "Explore how creating a professional identity can lead towards purposeful and fulfilling work in the future.",
            "assets": ["70735e05-8223-49c1-840d-952ab5a06906", "c2e776a1-3605-4302-82a0-9140600de49f"]
        },
        "practice": {
            "name": "Practice interviewing to make connections in industries and companies where students might want to work.",
            "assets": ["59c4425a-825e-4b9d-8db6-77728954959f", "caa8dc41-830e-4d49-a7a7-bf347f295509"]
        }
    },
    "dna-day": {
        "meta": true,
        "prioritize": ["6d70c04c-432d-4ba7-a6b6-077a6b756c71"],
        "dna-day-activities": {
            "name": "DNA Day Activities",
            "assets": [
                "e79aea59-17a2-43cf-a843-66baa202bc7d",
                "6d70c04c-432d-4ba7-a6b6-077a6b756c71",
                "9c6f6bd9-4df0-44c2-8d77-334a23ff8a2a",
                "fe72fc33-6956-4891-90d4-a49b63f8adcd"
            ]
        },
        "dna-in-our-day": {
            "name": "DNA in our Day",
            "assets": [
                "5cd8db76-d818-4754-a455-4d63e6a7a789",
                "b9a59e7d-2e13-4d48-92fb-14959ec2f124",
                "63543639-0241-4463-8973-5f5ce86c71db",
                "0b6a98f7-8a89-46d2-ad99-1fdec90e8a86"
            ]
        },
        "dna-careers": {
            "name": "Explore Careers Related to DNA",
            "assets": [
                "fdd2842f-a56e-4da6-9bfb-ecf57ebbddd4",
                "b1a3c3bb-8418-4a18-91d7-67fe0044861d",
                "e762e2f0-478f-4f92-bf37-e1071b30849e",
                "c3c30a75-8dd4-4003-b68a-82da028b0d24"
            ]
        }
    },
    "discovery-education": {
        "general": {
            "assets": [
                "c5a3918c-0f6a-4b97-b2f0-40de3f2655cb",
                "d7eddd3a-8bac-4cd1-945f-6fe3ab61dd12",
                "1704a25f-5440-470e-a868-47ea52416f88",
                "a5467293-27c5-42ef-96ea-82bf850b2678",
                "0d81cfe7-f15a-48a9-a3b5-2f7067155570",
                "b2fb4c4d-a680-49b0-bf4f-d1d27fc3305c",
                "c28d3507-a361-41fb-acac-3d67e0519d5e",
                "8707efdb-d5a0-4052-a188-78fa08cde452",
                "d4396346-8084-4f93-888d-0890a559781c",
                "eaada04a-a888-4058-a8a4-08839c19a48c",
                "baacd50a-1ca0-4741-a2d7-f638b0012223",
                "523f685e-457a-4336-8e1c-71fa34473999",
                "ff439f59-22c0-44bd-8b98-746c6f58f490",
                "c5a3918c-0f6a-4b97-b2f0-40de3f2655cb",
                "d7eddd3a-8bac-4cd1-945f-6fe3ab61dd12",
                "1704a25f-5440-470e-a868-47ea52416f88",
                "a5467293-27c5-42ef-96ea-82bf850b2678",
                "0d81cfe7-f15a-48a9-a3b5-2f7067155570",
                "b2fb4c4d-a680-49b0-bf4f-d1d27fc3305c",
                "c28d3507-a361-41fb-acac-3d67e0519d5e"
            ]
        }
    },
    "discover": {
        "general": {
            "assets": [
                "9eaf4a56-90d1-4d22-adf2-0a772f0f6f95",
                "60a9fce7-6437-44ee-98f7-73745bfbd386",
                "fbe16ea0-a79b-4522-9cbd-757daab2000a",
                "aa924f09-904d-4f39-95bc-a1284376d69c",
                "0b6be8fe-227e-4081-b36d-7557f9772a15"
            ]
        }
    },
    "norton": {
        "general": {
            "assets": [
                "7fe4246a-9c74-4f60-a91c-bbf41a92fdc6",
                "b89ec266-fcc8-4d4c-81e1-79817ff2a125",
                "e32f6a07-31db-46d2-abe2-5381c74377df",
                "280a79f0-f0ee-4d22-8e4c-53fe62590d3e",
                "51521906-8a2e-4a8e-910c-9f4c02e40680",
                "f3e7d7ad-a089-47b0-b67e-a0c68a48b402",
                "91528897-e0db-4204-8fb3-e11ff0b59a37",
                "c2b42ca2-5c13-4e38-b6b0-9c216f390179",
                "189f0a4a-e0c1-4831-ae35-217870503642"
            ]
        },
        "knowledge-building": {
            "name": "Knowledge Building",
            "assets": ["51521906-8a2e-4a8e-910c-9f4c02e40680", "f3e7d7ad-a089-47b0-b67e-a0c68a48b402"]
        },
        "workplace-skills": {
            "name": "Workplace Skills",
            "assets": ["189f0a4a-e0c1-4831-ae35-217870503642"]
        }
    },
    "nucor": {
        "general": {
            "assets": ["64dc3dbb-7dc2-47d8-938a-c2903f206805"]
        }
    },
    "asme": {
        "general": {
            "assets": [
                "49f94516-2e1e-46cf-ade6-4b38dea0ad1f",
                "97d9c737-72f6-4b42-9a25-60393b7f03ed",
                "c086ddda-3b40-48c7-8ed9-9b22d393ea19",
                "54acef6e-96d2-4a1e-9a15-b48f8b8d9950",
                "2846e2e6-c532-4fce-be21-5489abe81d85",
                "f297254a-b5d0-4fb9-838e-ac70799be4fe",
                "562f9ef1-8755-4b64-833b-7eab08c79f89",
                "a7dbb905-836e-4e6c-8328-0f1db6a0d370",
                "6950466f-7034-4db4-9f22-a649ec882fe0",
                "5fcef0d5-2249-4532-9dde-babea7fc4b76",
                "49922114-11e5-42aa-8c4f-354940d07b96",
                "9842d426-61cb-4bba-b550-03991ae47578",
                "940edd3a-81c4-4313-b95a-44f9ef6108bf",
                "37e9c385-8224-4159-8674-57925203c928",
                "e648ef90-4aba-4a2b-a639-e7a82c350d0f",
                "903f97ad-87ea-4081-a60e-69998416f972",
                "1c428099-7e6f-4101-bdd3-31bbc33a1a19",
                "fddf7915-4325-45be-8f80-3d4f680e8171",
                "989ddead-d05e-4dc6-8520-58f42f6f5eb8",
                "62750b4e-8ad1-402c-8c3d-cb4845122f18",
                "d409add9-6ac1-4007-8cd6-7c8d81b46396",
                "faa2f9cc-f4d3-4287-afea-1d58ae47024a",
                "de40943d-8830-452e-9ebc-0fcefb883614"
            ]
        }
    },
    "sanofi": {
        "general": {
            "assets": [
                "405e6b66-be3b-4843-a4de-4ad249ec9844",
                "c68c6c30-c880-4fe6-84f4-39601eabb352",
                "7656eae1-4afd-4fbe-81b3-d96ea4aa3d04",
                "a119f547-b020-444c-9a1f-21eb3111a34d",
                "e41e7e99-c92a-4f1f-a4a2-a92a46e65aa2",
                "8f849612-16fe-44bf-8669-889e8efa3281"
            ]
        }
    },
    "genentech": {
        "general": {
            "assets": [
                "c9f83110-a9d6-4e01-a017-2863018f9fff",
                "d0ce77d3-f1cc-4ded-8850-e269259e8d54",
                "25ae7b58-594a-4dfb-8043-b95d42a2c045",
                "c42799e3-f951-4c7c-a448-8d8f3e096b7f",
                "31d61785-5e6e-43d7-bec3-6c89f8fd3cea",
                "f8528e1e-d306-4eb7-b075-0cb67a67460e",
                "e762e2f0-478f-4f92-bf37-e1071b30849e",
                "28f7927a-b068-4c37-918e-ce96a46193df",
                "984a989c-14b3-4b34-a0ff-04f9535e354e",
                "d924b978-37da-4f56-ac48-e2b1f8b7538b",
                "3fb472e6-e93a-4133-8cd3-0fff9c18f772",
                "cd2ed766-3841-433a-82d3-962ceaba4990",
                "f642d867-dba5-469c-8351-e61a9525f5ce",
                "da6f8208-616c-4c9b-a583-9c4d8091145f",
                "ca8b3b39-ab29-4e5e-8a9a-1cd04c61bd67",
                "b818a190-e485-4bb3-aeb2-5c899a7c3b86",
                "4e6eb6a9-676c-46dd-947a-85ab4724df88",
                "0343a372-bd19-4523-87d5-3e57fe6b7d0e",
                "ad5a5a1c-03f6-459e-bbc4-f466e07dcf92",
                "bd9a7c97-61ed-498a-8463-d7eafcc7f74f",
                "46ebdeac-494e-4b70-9244-164a999b9da0",
                "b9a59e7d-2e13-4d48-92fb-14959ec2f124",
                "63543639-0241-4463-8973-5f5ce86c71db"
            ],
            "roles": {
                "d0ce77d3-f1cc-4ded-8850-e269259e8d54": ["employee"],
                "25ae7b58-594a-4dfb-8043-b95d42a2c045": ["employee"]
            }
        }
    },
    "lockheed-martin": {
        "general": {
            "assets": ["1079c44d-7f4c-4463-b55f-cae0c9aab725", "151ec328-a7bf-405a-9130-5e3cf402520f"]
        }
    },
    "lyda-hill": {
        "instructional-resources": {
            "name": "Instructional Resources",
            "assets": [
                "b9f9a4ea-ef81-4e72-ad9a-f091bef40ea2",
                "118b8c48-c570-4712-864a-cf6c2446132f",
                "4400f285-e22d-4808-a367-de0b782e3e09",
                "e5ddf187-a3fb-4f93-acd8-aaa5c8663138"
            ]
        },
        "career-support": {
            "name": "IF/THEN STEM Career Supports",
            "assets": ["9b4213f4-41a4-4c35-bc37-c25c6c21fd71", "2f8f7533-9bdc-47f6-af9c-dfde53c595df"]
        },
        "careers-in-computer-science": {
            "name": "Careers in Computer Science",
            "assets": [
                "f5c3c9cf-54d6-4afa-b5d5-5d8a1ecdb89a",
                "d1fb8391-64e6-410f-8175-e49cedec61d3",
                "c520c7f4-3da7-4746-8529-ec40ba770ed4",
                "f0a3e1c3-1a00-4c13-90bd-9714868057ca",
                "a7fdcd35-ee7c-496f-b84e-eba8e442d537"
            ]
        },
        "physical-science": {
            "name": "Physical Science",
            "assets": [
                "fddfe79a-14f9-440f-b4bd-9459a2e9bb8a",
                "eb0c3a15-339d-413f-9d3f-f115e265fd7b",
                "efaa32f7-0103-4ad7-95d4-f4ceef1f8d85",
                "1efa8c51-f1ab-40f5-bbad-8854b3cf0afc",
                "c1ec14f8-2dc1-4341-ac37-43311f97b83a",
                "108a3227-60ec-4308-bf1b-0cd9a708d15e",
                "83346305-86f5-44e3-8fd8-69983ad1774b",
                "376b5c7e-6d1e-403a-9162-b3cb2e8ab9b6",
                "ec27de93-7637-4dd3-abdf-117d29cb3dfd",
                "ed388eb7-34e1-4c37-a481-43013d108d68",
                "bba1c57c-990f-40d9-baa8-301de11a6e8e",
                "7f871df6-c337-40d8-a48a-3de48b4e93c4"
            ]
        },
        "information": {
            "name": "Information, Communication, Computer Science",
            "assets": [
                "d795e6d6-5041-475a-99f1-d7ebfc85e69d",
                "fdb5b9d2-2053-4da5-8730-18701a32d396",
                "4e8a88e3-6c83-4557-9f2d-3740698e091c",
                "5b842e22-780f-42d9-a1ab-d8ad822dbd31",
                "f0a3e1c3-1a00-4c13-90bd-9714868057ca",
                "c520c7f4-3da7-4746-8529-ec40ba770ed4",
                "7ace5525-1a51-43b2-8261-8df3b9548506",
                "a7fdcd35-ee7c-496f-b84e-eba8e442d537",
                "0b2766d0-9e1a-4662-b22c-17d39f945bc1",
                "2eea4236-5d01-4839-8ebc-e51999404a0c",
                "02f0c174-7daf-4ffd-b58b-692fd6c03f8b",
                "cd0efb03-1c51-41fa-9d29-34ef5911e16a"
            ]
        },
        "life-science": {
            "name": "Life Science",
            "assets": [
                "c1c3cf2f-4b0b-4340-bcac-90961b52f129",
                "4b532f08-20d4-47b2-9b5b-28f3423176c7",
                "d4ed8e4e-1e48-4266-b81e-0b2ca05f45ce",
                "e7c63d2a-0246-4a54-9c78-965b845284f6",
                "29c029a0-3b5c-4bf6-8ef6-253033b05690",
                "1fb0360b-1e3b-4fe2-8b00-d40e7cfc7d39",
                "ad4bcd5d-7c95-4662-9816-fbd69a06a076",
                "d81fe1ca-1694-4ab9-876d-6d6e4e59a6ee",
                "daae2a52-3d0f-40ab-9ca1-e8b335adbdc2",
                "e149f7dc-77fe-4f54-a5dd-e59aa3861959",
                "a9f2bdeb-a82c-408d-838e-72d603e847c3",
                "f7a4bccf-b93a-4f8d-a862-4a5a0dc345ac",
                "de7047e1-2f44-426e-880d-419db5939e90",
                "fdd2842f-a56e-4da6-9bfb-ecf57ebbddd4",
                "fbe84900-e072-452a-aad1-7217e3ef4aba",
                "fa4d42a1-0298-40a5-b8d0-c277198dcba8",
                "b1a3c3bb-8418-4a18-91d7-67fe0044861d"
            ]
        },
        "earth-and-space": {
            "name": "Earth and Space Science",
            "assets": [
                "2953b5b2-2626-4811-92c6-00ff465ed18a",
                "d83cbf47-ea22-4e93-9f2b-14a1815497c7",
                "bddaffac-6a51-48e4-b4dd-9f837fc3316b",
                "93e99948-d9e2-4e96-b9eb-e87f7a79f304",
                "76bbcd51-3a76-45b4-a3dd-e986d14f1518",
                "13e2e2e2-bbda-44d4-a45f-17365136fc71",
                "02e704d1-dc0b-4ffe-a317-d036145b2c18",
                "78f3cc91-5d0c-4333-8424-48c635560d94",
                "e904bb96-573e-4d85-8719-a6eee822046a",
                "c81b3ba8-ecfb-4658-bd60-915158bbf304",
                "b6f56dd1-4f50-44b9-8a13-da94368d1e45",
                "bbfc5653-1d74-45a1-be2c-13717be042cd"
            ]
        }
    },
    "trane": {
        "general": {
            "assets": [
                "330fe45b-a43e-458b-956f-3d79615635c2",
                "a2437644-81ea-40de-98bd-5c4212768ab0",
                "ec317668-e8ac-4fa9-8ae5-5fbb5036c504",
                "8f005b01-d02f-4df6-878f-ffd66c5d2b6c",
                "4cd8f489-53a6-4374-a579-d50f061c6e49",
                "e4739c29-28d0-49bf-914c-817871267faa",
                "da2e5c09-c1ce-4c37-a7cd-1f52452e3315",
                "9c488095-2b83-441a-b398-a38432a41667"
            ]
        },
        "career-exploration": {
            "name": "Career Exploration",
            "assets": ["814c429e-7d27-42ab-818a-96e39c99cf9f", "0ed5ad99-71bb-4b4a-a3e1-48c5125bd720"]
        },
        "knowledge-building": {
            "name": "Knowledge Building",
            "assets": [
                "7ac919f5-f110-44d2-9eb7-b072151483c4",
                "d90c1db6-adc6-417d-b4e2-b6303f54d167",
                "b9741c86-cd1b-48bf-9ca7-4c0d7724f51b",
                "c235b4ce-bbbe-4ab4-8576-076720516a93"
            ]
        },
        "workplace-skills": {
            "name": "Workplace Skills",
            "assets": ["e3591f2e-c7d6-4652-8c02-7a1582bdf6e1"]
        }
    },
    "boeing": {
        "career-exploration": {
            "name": "Career Exploration",
            "assets": [
                "600aca20-18d1-40c4-983c-67bd89ceda85",
                "e40753be-7fe4-4165-8496-e8e534cf0e4b",
                "18095b9d-8891-4a06-82e4-4e07124c3d7a",
                "1ec6ea8a-fd57-42d3-8e9d-d67690c8a2a1",
                "d8304606-4989-4937-892c-e882409eb508",
                "d304350a-58db-4877-a64a-463f982268d9"
            ]
        },
        "career-planning": {
            "name": "Career Planning",
            "assets": [
                "79912d5c-7db0-4c78-ae0b-4f5bab4fcab3",
                "5e349953-5d75-47a4-bf20-fac5dada6027",
                "99c45e04-465a-4c6e-9451-c3f5a7f56b5e",
                "bbaaa307-0122-4c51-b17e-5c9a3da0dedb",
                "7d7a5d81-15f2-418e-a97d-a653a92b4434",
                "aea64676-eedc-439f-9d4a-29c8e563ee43",
                "7cbcf67b-a0e3-4204-8d8c-735f44180df0",
                "aff7eb32-7daf-468b-af50-ae634f9bd936",
                "94352757-37ce-4f59-bc82-302375e4c856"
            ]
        },
        "knowledge-building": {
            "name": "Knowledge Building",
            "assets": [
                "fdfea67c-a8cd-4c76-a275-a5c74c565247",
                "6c11b745-c505-4eff-8e23-c01889ede86c",
                "fc157d4c-92a1-485c-94ad-a95c9f6d3dc8",
                "0b606ce0-da29-4486-8557-94eb504bac05",
                "de1578c3-8fe1-41c2-941d-efcc2d75ef35",
                "1255f2af-463c-486e-a8ae-3d83d4dedae4",
                "68f6c022-acc1-4cf6-9dc4-7122d09757ee",
                "bf3f707a-8efb-4359-99f2-8f7ee65b064c",
                "3a969d6a-c82a-499e-a2b8-93048dd005bb"
            ]
        },
        "workplace-skills": {
            "name": "Workplace Skills",
            "assets": [
                "6147e5cf-2435-41e8-8db4-888c0fc72643",
                "2bb2fbce-2c50-4c8a-bd8f-d892f1697e8c",
                "d3532ecf-9899-4007-85bd-11db6009f0a6",
                "1bedeba3-f379-4b01-9566-11226ce66a34",
                "eabe2fdc-d117-4a9c-878b-a309309df467",
                "ca643a2e-6e92-4b60-b6da-9ef2ec37c1fb"
            ]
        }
    },
    "val-skinner": {
        "career-exploration": {
            "name": "Career Exploration",
            "assets": ["6b30d453-18ce-4e41-b6eb-c55471349ac6", "5fc0d9dc-d8b4-4475-8d78-1b8e02d77d5e"]
        },
        "knowledge-building": {
            "name": "Knowledge Building",
            "assets": ["f88911a2-fb5a-49ee-8302-69d777793f2e"]
        },
        "workplace-skills": {
            "name": "Workplace Skills",
            "assets": ["06b86236-37cf-43c0-a84a-96afb4122d43"]
        }
    },
    "dupont": {
        "career-exploration": {
            "name": "Career Exploration",
            "assets": ["3105e386-8159-4fd8-b9d1-5ac4c7e0cd39", "c9ea8e08-4a70-4d47-8861-3f4ede27fccb", "e32ff00e-e7b9-4f71-bd5b-83de57f53ed5"]
        },
        "career-planning": {
            "name": "Career Planning",
            "assets": ["f717b873-37b6-4e55-a648-a48fc6ca1d0c"]
        },
        "knowledge-building": {
            "name": "Knowledge Building",
            "assets": ["3894d039-8f91-49b1-9edd-da493cfe6d2c", "9907cc34-630a-46f7-9462-71e219a0efd0"]
        },
        "workplace-skills": {
            "name": "Workplace Skills",
            "assets": ["3721a7e5-2466-4a3a-8fc4-49d19a1ca086", "9c2d8cbd-2e39-4bf5-b8d9-761d2a7b0c40", "4dddc2dd-31ac-455d-9758-768a686fed82"]
        }
    },
    "us-bank": {
        "general": {
            "assets": [
                "b120a2fc-3fc9-4265-ad97-6302b5d14317",
                "522262b7-f9b9-4de7-a619-d4a8a6a69e95",
                "1442603b-fa8c-4274-8171-2686a25a8eab",
                "5f72e84d-ff18-4f01-920b-f7d226145ae8",
                "05a654c5-109f-4bc7-9d54-ad3c0923dec5",
                "0cb306ac-de0c-4334-b1dc-4c356deba524"
            ],
            "roles": {
                "b120a2fc-3fc9-4265-ad97-6302b5d14317": ["employee"],
                "522262b7-f9b9-4de7-a619-d4a8a6a69e95": ["employee"],
                "1442603b-fa8c-4274-8171-2686a25a8eab": ["employee"],
                "5f72e84d-ff18-4f01-920b-f7d226145ae8": ["employee"],
                "05a654c5-109f-4bc7-9d54-ad3c0923dec5": ["employee"],
                "0cb306ac-de0c-4334-b1dc-4c356deba524": ["employee"]
            }
        }
    }
}
